import { ItemRevision } from './item-revision';

export class ItemStructure {
  public constructor(
    public itemId: string,
    public itemName: string,
    public itemType: string,
    public revisions: ItemRevision[]
  ) {}
}
